import { AppClientConfigurationService, DialogService } from '@sdbn/common';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

export class TerminalConfigurationController extends AbstractStepController {

    configurationService: AppClientConfigurationService;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(AppClientConfigurationService);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
      const config = this.wizardComponent.currentStep.dashboardConfiguration;
      const terminalIdentifier = config.terminalIdentifier;
      if (terminalIdentifier != null) {
        this.dashboardContext.setContextValue('terminalIdentifier', terminalIdentifier);
        // FIXME: 28.04.25 MZ FIX
        const deviceParameter = this.configurationService.getDeviceParameter(terminalIdentifier);
        console.log('device parameter loaded', deviceParameter);
      }
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.NEXT;
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private showHttpError() {
        const dialogService = WizardServiceLocator.injector.get(DialogService);
        dialogService.showInfoDialog(
          'tmc-yard.widgets.registration-terminal.http.error.title',
          'tmc-yard.widgets.registration-terminal.http.error.message'
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }
}
